/**
 * Error模块路由配置
 * 定义错误页面的路由规则
 * @author AI Assistant
 * @date 2024-01-09
 */

import type { ModuleRouteItem } from '@/types/module-config'

/**
 * Error模块路由配置
 */
const errorRoutes: ModuleRouteItem[] = [
  {
    path: '/404',
    name: 'error-404',
    component: '../pages/404.vue',
    meta: {
      title: '页面未找到',
      hideInMenu: true,
      hideInTabs: true,
      noAuth: true
    }
  },
  {
    path: '/403',
    name: 'error-403',
    component: '../pages/403.vue',
    meta: {
      title: '访问被拒绝',
      hideInMenu: true,
      hideInTabs: true,
      noAuth: true
    }
  },
  {
    path: '/500',
    name: 'error-500',
    component: '../pages/500.vue',
    meta: {
      title: '服务器错误',
      hideInMenu: true,
      hideInTabs: true,
      noAuth: true
    }
  }
]

export default errorRoutes
